import Axios from "@/plugins/Axios";
import store from "@/store";
import Turma from "@/Models/Turma";

export class TurmasService {
  async syncAll() {
    const response = await Axios().get("turmas");

    const turmas = response.data.map((turma) => new Turma(turma));

    return turmas;
  }

  async syncAllPaginate(pageNumber, query) {
    const response = await Axios().get(`turmas/listall/paginate?page=${pageNumber}&query=${query}`);

    return response.data;
  }

  async syncAllGeral() {
    const response = await Axios().get("turmas/retirarFiltroFranquia");

    const turmas = response.data.map((turma) => new Turma(turma));

    return turmas;
  }

  async visualizarTurma(turma) {
    const response = await Axios().get(`turmas/visualizar/${turma}`);

    const novaTurma = response.data;
    store.commit("Turmas/visualizarTurma", novaTurma);

    return novaTurma;
  }

  async criarTurma(turma) {
    const response = await Axios().post("turmas", turma);
    const novaTurma = response.data;

    store.commit("Turmas/adicionarTurma", novaTurma);

    return novaTurma;
  }

  async listarTurmasFranquiaSelect(form) {
    const response = await Axios().post("turmas/listar-turmas-franquia-select", form);

    const turmas = response.data.map((turma) => new Turma(turma));

    return turmas;
  }

  async atualizarTurma(turma) {
    const response = await Axios().put(`turmas/${turma.id}`, turma);

    const turmaAtualizada = response.data;
    store.commit("Turmas/atualizarTurma", turmaAtualizada);

    return turmaAtualizada;
  }

  async deletarTurma(turma) {
    const response = await Axios().delete(`turmas/${turma.id}`);

    const turmaDeletada = response.data;
    store.commit("Turmas/deletarTurma", turma.id);

    return turmaDeletada;
  }

  async recuperarTurma(turma) {
    return this.atualizarTurma({ ...turma, deleted_at: null });
  }

  async pegarMatriculas(turma) {
    const response = await Axios().get(`turmas/pegar-matriculas/${turma}`);

    return response.data;
  }

  async listTurmasEspecias() {
    const response = await Axios().get("turmas/turmas-especias/inclusiva");

    const turmas = response.data.map((turma) => new Turma(turma));

    return turmas;
  }

  async pegarNotas(turmas) {
    const response = await Axios().post(`turmas/notas/metricas`, turmas);

    return response;
  }

  async pegarMedias(turmas) {
    const response = await Axios().post(`turmas/medias/metricas`, turmas);

    return response;
  }

  async pegarMelhoresAlunos(turmas) {
    const response = await Axios().post(`turmas/melhores-alunos/metricas`, turmas);

    return response;
  }

  async pegarMelhoresAlunosDaGestao(turmas, gestao) {
    const response = await Axios().post(`turmas/melhores-alunos/metricas-gestao`, turmas, gestao);

    return response;
  }

  async pegarAcompanhamentos(turmas) {
    const response = await Axios().post(`turmas/acompanhamentos/metricas`, turmas);

    return response;
  }

  async mostrarTurma(turma_id) {
    const response = await Axios().get(`turmas/visualizar/${turma_id}/metricas`);

    return response;
  }

  async qtd() {
    const response = await Axios().get("turmas/qtd");

    return response.data;
  }

  async taxaOcupacao() {
    const response = await Axios().get("turmas/taxa-ocupacao");

    return response.data;
  }

  async syncAllPaginateFranquia(pageNumber, franquia) {
    const response = await Axios().get(
      `turmas/listallFranquia/paginate?page=${pageNumber}&franquia=${franquia}`
    );

    return response.data;
  }

  async getTurmasAnoSeguinte(ano_id, franquia_id = null) {
    try {
      if (!ano_id) {
        console.error("Ano ID não definido");
        return { turmas: [] };
      }

      const response = await Axios().get(`turmas/ano-seguinte/${ano_id}`, {
        params: franquia_id ? { franquia_id } : {},
      });

      return response.data?.turmas ? response.data : { turmas: [] };
    } catch (error) {
      console.error("Erro ao buscar turmas do ano seguinte:", error);
      return { turmas: [] };
    }
  }

  async migrarTurma(turmaId) {
    const response = await Axios().post(`turmas/migrar-turma/${turmaId}`);

    return response.data;
  }

  async migrarTodasTurmas(franquia_id) {
    const response = await Axios().post(`turmas/migrar-turmas-franquias/${franquia_id}`);

    return response.data;
  }

  async quadroHorario(turma_id) {
    const response = await Axios().get(`turmas/quadroHorario/${turma_id}`);

    return response.data;
  }

  async bolsaFamilia(turma_id, mes_1, mes_2) {
    const response = await Axios().post(`turmas/bolsa-familia`, {
      turma_id,
      mes_1,
      mes_2,
    });

    return response.data;
  }

  async pegarMotivosFaltas(turma_id, mes_1, mes_2) {
    const response = await Axios().get(
      `turmas/bolsa-familia/motivos-faltas/${turma_id}/${mes_1}/${mes_2}`
    );

    return response.data;
  }

  async salvarMotivosFaltas(data) {
    const response = await Axios().post(`turmas/bolsa-familia/salvar-motivos-faltas`, {
      codigo: data.codigo,
      turma_id: data.turma_id,
      matricula_id: data.matricula_id,
      mes: data.mes,
    });

    return response.data;
  }

  async removerMotivoFalta(data) {
    const response = await Axios().post(`turmas/bolsa-familia/remover-motivos-faltas`, {
      codigo: data.codigo,
      turma_id: data.turma_id,
      matricula_id: data.matricula_id,
      mes: data.mes,
    });

    return response.data;
  }

  async gerarRelatorioFrequenciaBolsaFamilia(turma_id, mes_1, mes_2) {
    const response = await Axios()
      .get(`turmas/bolsa-familia/motivos-faltas/${turma_id}/${mes_1}/${mes_2}/pdf`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });

    return response;
  }

  async listarTurmasFundamentalFranquia(franquia) {
    const response = await Axios().post("turmas/listar-turmas-fundamental-franquia", franquia);

    const turmas = response.data.map((turma) => new Turma(turma));

    return turmas;
  }
}

export default new TurmasService();
